import Service         from '@/api/service';
import { getKeyValue } from '@/composables/formatData';

export async function getKeyValueActorsArray(tenantId, folderId, type) {

  const searchParams = {
    'dossierId:eq' : folderId,
    'actorType:eq' : 'agent'
  };

  if (type) {

    searchParams['movementType:eq'] = type;
  }

  const actors = await Service.getActorsWithoutPagination(tenantId, { searchParams });
  const formattedActors = [];

  for (const actor of actors) {

    formattedActors.push(await formatActor(tenantId, actor));
  }

  return formattedActors;
}

export async function formatActor(tenantId, actor) {

  const user = await getKeyValue(tenantId, actor.userId);
  return {
    id      : actor.id,
    user    : user,
    percent : actor.percent,
    main    : actor.main,
    manual  : actor.manual,
    history : actor.history
  };
}

export async function useUpdateSplitsAgents(tenantId, folderId, oldFolder, newFolder) {

  const mandateAgentsHasChanged = JSON.stringify(newFolder.mandateAgents) !== JSON.stringify(oldFolder.mandateAgents);
  const saleAgentsHasChanged = JSON.stringify(newFolder.saleAgents) !== JSON.stringify(oldFolder.saleAgents);
  const clientAgentHasChanged = JSON.stringify(newFolder.clientAgents) !== JSON.stringify(oldFolder.clientAgents);

  if (mandateAgentsHasChanged) {
    await useUpdateSplitAgents(tenantId, folderId, oldFolder, newFolder, 'mandate');
  }

  if (saleAgentsHasChanged) {
    await useUpdateSplitAgents(tenantId, folderId, oldFolder, newFolder, 'sale');
  }

  if (clientAgentHasChanged) {
    await useUpdateSplitAgents(tenantId, folderId, oldFolder, newFolder, 'client');
  }
}

export async function useUpdateSplitAgents(tenantId, folderId, oldFolder, newFolder, type) {

  const key = `${ type }Agents`;

  for (const agents of newFolder[key]) {

    delete agents.history;
  }

  for (const agents of oldFolder[key]) {

    delete agents.history;
  }

  const addedAgents = newFolder[key].filter(x => !JSON.stringify(oldFolder[key]).includes(x.user.key));
  const removedAgents = oldFolder[key].filter(x => !JSON.stringify(newFolder[key]).includes(x.user.key));

  const isSameFolder = newFolder.id === oldFolder.id;
  const changedAgents = [];

  for (const agent of newFolder[key]) {

    const foundAgent = oldFolder[key].find(oldAgent => agent.user.key === oldAgent.user.key);
    if (foundAgent && (agent.percent !== foundAgent.percent || agent.main !== foundAgent.main)) {

      // Si le dossier n'est pas le même c'est que c'est une copie. On regarde donc si le dossier enfant (oldFolder) a
      // des acteurs différents du dossier parent (newFolder). Si c'est le cas, on récupère les données du dossier
      // parent mais on récupère l'id du dossier enfant pour le modifier
      changedAgents.push(isSameFolder ? agent : {
        id : foundAgent.id, percent : agent.percent, user : agent.user, main : agent.main
      });
    }
  }

  for (const changedAgent of changedAgents) {

    if (!changedAgent.user.key) {

      return;
    }

    await Service.updateActor(tenantId, changedAgent.id, {
      percent : changedAgent.percent,
      main    : changedAgent.main
    });
  }

  for (const removedAgent of removedAgents) {

    await Service.deleteActor(tenantId, removedAgent.id);
  }

  for (const addedAgent of addedAgents) {

    if (!addedAgent.user.key) {

      return;
    }

    await Service.createActor(tenantId, {
      dossierId    : folderId,
      userId       : addedAgent.user.key,
      actorType    : 'agent',
      movementType : type,
      percent      : addedAgent.percent,
      main         : addedAgent.main,
      manual       : true
    });
  }
}